class AuthWithConnectionCtrl {
  constructor(ENVIRONMENT, PROVIDERS, AuthService, FlashService, $window, $stateParams, $state, $scope) {
    'ngInject';
    this.AuthService = AuthService;
    this.FlashService = FlashService;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$scope = $scope;
    this.$window = $window;
    this.PROVIDERS = PROVIDERS;
    this.ENVIRONMENT = ENVIRONMENT;
    this.errorMessage = null;
    this.loading = true;
  }

  async $onInit() {
    let authData = null;
    try {
     
      await this.AuthService.logout(true);

      try {
        authData = JSON.parse(this.$stateParams.authData);
      }
      catch {
        throw new Error ('Invalid or missing authentication data!');
      }

      if (!authData.provider || !this.PROVIDERS[authData.provider]) {
        throw new Error('Invalid provider!');
      }
      
      try {
        await this.AuthService.login(authData);
      }
      catch (logErr) {
        throw new Error (logErr.message || 'Cannot log in. Please check your credentials are valid!');
      }

      this.FlashService.success("Logged in successfully.");
      if (this.$stateParams.authRedirect) {
        this.isFunction = this.isFunctionRedirect(this.$stateParams.authRedirect);
        let connParam = this.isFunction ? "&connection=" + encodeURIComponent(JSON.stringify(authData)) : "";
        this.$window.location.replace(decodeURIComponent(this.$stateParams.authRedirect) + connParam);
        if (this.isFunction) this.loading = "";
      }
      else {
        this.$state.go("app.form-builder", {});
      }

    } catch (error) {

      this.loading = false;
      this.errorMessage = error.message;
      this.$scope.$apply();
    }
  }

  // Only append the connection (which carries the user's provider token/ticket) when the
  // post-login redirect targets one of OUR function endpoints. Compare the decoded URL's
  // origin/host exactly — a substring check let a crafted redirect that merely contains the
  // host (e.g. https://attacker.example/cb?x=<functions-host>) harvest the token.
  isFunctionRedirect(rawRedirect) {
    let url;
    try {
      url = new URL(decodeURIComponent(rawRedirect));
    } catch (e) {
      return false;
    }
    const { functionsBaseUrl, localPort } = this.ENVIRONMENT.firebase;
    const allowedOrigins = [];
    if (functionsBaseUrl) allowedOrigins.push(new URL(functionsBaseUrl).origin);
    if (localPort) allowedOrigins.push(`http://localhost:${localPort}`, `http://127.0.0.1:${localPort}`);
    return allowedOrigins.includes(url.origin);
  }
}

export default {
  bindings: {
  },
  templateUrl: "user/auth-with-connection/auth-with-connection.component.html",
  controller: AuthWithConnectionCtrl
}
